<template>
  <QDialog v-model="showDialog">
    <QCard class="lease-inclusion-dialog full-width q-pa-md" style="max-width: 700px">
      <QCardSection class="column items-center q-pa-none q-ma-none full-width scroll">
        <QCardSection class="column q-pa-none full-width">
          <QBtn
            rounded
            class="calculator-dialog-close"
            flat
            :icon-right="closeIconCircle"
            size="16px"
            color="primary"
            align="left"
            @click="handleClose"
          >
            Close
          </QBtn>

          <QCardSection class="estimated-payments-modal__content column full-width">
            <p class="estimated-payments-modal__header">Estimated Payments</p>
            <p class="estimated-payments-modal__body">{{ content }}</p>
            <CalculatorButton
              color="primary"
              label="Enquire now"
              rounded
              class="estimated-payments-modal__cta"
              @click="handleRequestQuote"
            />
          </QCardSection>
        </QCardSection>
      </QCardSection>
    </QCard>
  </QDialog>
</template>

<script>
import { QDialog, QCard, QCardSection, QBtn } from 'quasar';
import { evaCloseCircleOutline } from '@quasar/extras/eva-icons';
import CalculatorButton from '../CalculatorButton.vue';

export default {
  props: {
    value: Boolean
  },
  name: 'EstimatedPaymentsModal',
  data: function () {
    return {
      showDialog: false,
      closeIconCircle: evaCloseCircleOutline
    };
  },
  created() {
    this.showDialog = this.value;
  },
  computed: {
    content() {
      return 'The estimated payments shown are calculated based on travelling 15,000km annually over the lease term selected below.\n\nEnquire now to get a custom quote for your business.';
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.showDialog = val;
      }
    }
  },
  methods: {
    handleClose() {
      this.showDialog = false;
      this.$emit('onClose', false);
    },
    handleRequestQuote() {
      this.showDialog = false;
      this.$emit('onClose', false);
      this.$emit('request-quote');
    }
  },
  components: {
    QDialog,
    QCard,
    QCardSection,
    QBtn,
    CalculatorButton
  }
};
</script>

<style lang="sass" scoped>
.estimated-payments-modal__content
  max-width: 700px
  display: flex
  flex-direction: column
  gap: 32px
  align-items: flex-start

.estimated-payments-modal__header
  color: var(--q-color-primary)
  font-family: var(--calculator-font-family, 'Nunito', sans-serif)
  font-size: 32px
  font-style: normal
  font-weight: 700
  line-height: 120%

.estimated-payments-modal__body
  font-family: var(--calculator-font-family, 'Nunito', sans-serif)
  font-weight: 500
  font-size: 18px
  line-height: 1.5
  color: var(--q-color-primary)
  margin: 0
  white-space: pre-wrap

.estimated-payments-modal__cta
  @media (max-width: 1199px)
    width: 100%
  @media (min-width: 768px) and (max-width: 1199px)
    min-width: 0
  @media (min-width: 1200px)
    width: 160px
    min-width: 160px
    max-width: 160px
</style>
